var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96875 12.9297H0.585938C0.26207 12.9297 0 12.6676 0 12.3438V1.79688C0 1.47301 0.26207 1.21094 0.585938 1.21094H14.6875C15.0114 1.21094 15.2734 1.47301 15.2734 1.79688V4.14062C15.2734 4.46449 15.0114 4.72656 14.6875 4.72656H5.89844V7.65625C5.89844 7.98012 5.63637 8.24219 5.3125 8.24219H3.55469V12.3438C3.55469 12.6676 3.29262 12.9297 2.96875 12.9297Z",
    fill: "#FFCB66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 1.21094H10V4.72656H14.6875C15.0114 4.72656 15.2734 4.46449 15.2734 4.14062V1.79688C15.2734 1.47301 15.0114 1.21094 14.6875 1.21094Z",
    fill: "#FFA54D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 15.2734H17.0312C16.7074 15.2734 16.4453 15.0114 16.4453 14.6875V8.24219H5.3125C4.98863 8.24219 4.72656 7.98012 4.72656 7.65625V4.14062C4.72656 3.81676 4.98863 3.55469 5.3125 3.55469H19.4141C19.7379 3.55469 20 3.81676 20 4.14062V14.6875C20 15.0114 19.7379 15.2734 19.4141 15.2734Z",
    fill: "#E6F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 3.55469H10V8.24219H16.4453V14.6875C16.4453 15.0114 16.7074 15.2734 17.0312 15.2734H19.4141C19.7379 15.2734 20 15.0114 20 14.6875V4.14062C20 3.81676 19.7379 3.55469 19.4141 3.55469Z",
    fill: "#CFE6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0312 7.07031H2.96875C2.64059 7.07031 2.38281 7.32809 2.38281 7.65625V18.2031C2.38281 18.3672 2.45312 18.5078 2.54687 18.625L6.48438 17.0313H11.1719L17.4531 18.625C17.5469 18.5078 17.6172 18.3672 17.6172 18.2031V7.65625C17.6172 7.32809 17.3594 7.07031 17.0312 7.07031Z",
    fill: "#66B3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0312 7.07031H10V17.0313H11.1719L17.4531 18.625C17.5469 18.5078 17.6172 18.3672 17.6172 18.2031V7.65625C17.6172 7.32809 17.3594 7.07031 17.0312 7.07031Z",
    fill: "#4D88FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4531 18.6254C17.3359 18.7192 17.1953 18.7895 17.0313 18.7895H2.96875C2.80469 18.7895 2.66406 18.7192 2.54688 18.6254L6.07004 15.1023C6.29887 14.8735 6.66984 14.8735 6.89867 15.1023L7.24191 15.4455C7.47074 15.6744 7.84172 15.6744 8.07055 15.4455L10.7575 12.7585C10.9864 12.5297 11.3573 12.5297 11.5862 12.7585L17.4531 18.6254Z",
    fill: "#ADE65C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48438 12.9297C5.51508 12.9297 4.72656 12.1412 4.72656 11.1719C4.72656 10.2026 5.51508 9.41406 6.48438 9.41406C7.45367 9.41406 8.24219 10.2026 8.24219 11.1719C8.24219 12.1412 7.45367 12.9297 6.48438 12.9297Z",
    fill: "#FFCB66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7575 12.7575L10 13.5151V18.7886H17.0313C17.1953 18.7886 17.3359 18.7183 17.4531 18.6245L11.5862 12.7575C11.3573 12.5287 10.9864 12.5287 10.7575 12.7575Z",
    fill: "#7ACC52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/Gallery.16c5de736ddcaaa01f7ba6f941002318.svg";
export { ForwardRef as ReactComponent };